import { render, staticRenderFns } from "./TenderOfferVersionOldBadge.vue?vue&type=template&id=049e494d&"
import script from "./TenderOfferVersionOldBadge.vue?vue&type=script&lang=js&"
export * from "./TenderOfferVersionOldBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports